import { ModularBlockComponent } from '@commerce-webcomponents/ui-composite';
import { NextgenImage, useNextgenRouter, useSession } from '@nextgen-web-framework/all';
import useLivePreview from '../../../live-preview/useLivePreview';
import Layout from '../../../components/Layout/Layout';
import withNextGenISR from '../../../utils/withNextGenISR';
import SEOComponent from '../../../components/SEOComponent/SEOComponent';
import { PageCategory, CMSTransformerDataType } from '../../../types/common';
import { getContentPageData } from '../../../utils/getEssentials';
import { getInvalidateTime } from '../../../utils/common';
import styles from './LandingTemplate.module.scss';
import { sanitizationConfig } from 'utils/sanitizationUtils';
import { TemplateType, getComponentStylesConfig } from 'utils/componentsStylingConfigs';
import usePageContent from 'components/PageContent/usePageContent';
import PageContentErrorHandler from 'components/PageContent/PageContentErrorHandler';
import withFeatureFlags from 'utils/withFeatureFlags';

const FlexTemplate = ({ data: initialData, params, notFoundPageData }: CMSTransformerDataType) => {
  const header = initialData?.layout?.header;
  const footer = initialData?.layout?.footer;
  const config = ConfigService.getConfigs();
  const ASSETS_BASE_PATH = config.NEXT_ASSETS_BASE_PATH;
  const router = useNextgenRouter();
  const { session } = useSession();
  const flexTemplateContent = usePageContent({
    initialData: initialData,
    locale: params?.locale as string,
    uId: 'flex_template',
    queryUrl: `/landing/${params?.slug[0]}`,
    enableFlag: config.NEXT_PUBLIC_ENABLE_AMWAY_RESTRICTION as string,
    userType: session?.type,
  });
  const [pageData, seoState] = useLivePreview(flexTemplateContent.data, flexTemplateContent?.data?.seo_config);
  const componentStylesConfig = getComponentStylesConfig(TemplateType.FLEX);
  return (
    <PageContentErrorHandler content={flexTemplateContent} notFoundData={notFoundPageData}>
      <Layout
        hasTopMobileHeader={true}
        headerProps={{
          isBackNavigation: false,
          isStaticHeader: true,
          headerElement: (
            <div className={styles['amway-logo']}>
              {' '}
              <NextgenImage
                data-testid="amway-logo-testid"
                onClick={() => {
                  router.push('/');
                }}
                src={`${ASSETS_BASE_PATH}/images/AmwayFullLogo-Black.svg`}
                alt={'Amway Logo'}
              />
            </div>
          ),
        }}
        hideLocationSelector={true}
        header={header}
        footer={footer}
      >
        <SEOComponent {...seoState} />
        {pageData.content_section && (
          <ModularBlockComponent
            sanitizeComponentsConfig={sanitizationConfig}
            data={pageData.content_section}
            componentStylesConfig={componentStylesConfig}
          />
        )}
      </Layout>
    </PageContentErrorHandler>
  );
};

export const getStaticPaths = () => ({
  paths: [],
  fallback: 'blocking', //indicates the type of fallback
});

export const getStaticProps = withNextGenISR(async (context) => {
  const {
    data: cmsData,
    notFoundData,
    showError,
  } = await getContentPageData({
    params: context.params,
    uId: 'flex_template',
    url: `/landing/${context.params?.slug && context.params?.slug[0]}`,
  });

  return {
    props: {
      data: cmsData,
      showError: cmsData ? showError : true,
      notFoundPageData: notFoundData,
      params: context?.params,
    },
    revalidate: getInvalidateTime(PageCategory.DEFERRED),
  };
});
export default withFeatureFlags(FlexTemplate);
